module.exports = __webpack_public_path__ + "media/public/img/google-review-widget-01-9059a9fdc528e00fb7c57bef480f34dd.svg";